import { ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';

export enum ListStatus {
  Active = 'active',
  Archived = 'archived',
}

export interface ListAttributes {
  name: string;
  status?: ListStatus;
  'environment-id'?: string;
  'archived-at'?: string;
  'created-at'?: string;
  'updated-at'?: string;
  'user-name-full'?: string;
  'list-item-count-active'?: string;
  'items-expire-after-days'?: number;
  'retention-period-seconds'?: number;
}

export interface ListNameAttributes extends ListAttributes {
  'allow-fuzzy-name-first': boolean;
}

export interface ListFieldAttributes extends ListAttributes {
  'field-name': string;
}

export interface ListRelationships {
  user: ApiRelationship<ApiModel.User>;
}

export type ListGovernmentIdNumber = ApiResource<
  ListAttributes,
  ListRelationships,
  ApiModel.ListGovernmentIdNumber
>;
export type ListIpAddress = ApiResource<ListAttributes, ListRelationships, ApiModel.ListIpAddress>;
export type ListName = ApiResource<ListNameAttributes, ListRelationships, ApiModel.ListName>;
export type ListPhoneNumber = ApiResource<
  ListAttributes,
  ListRelationships,
  ApiModel.ListPhoneNumber
>;
export type ListEmailAddress = ApiResource<
  ListAttributes,
  ListRelationships,
  ApiModel.ListEmailAddress
>;
export type ListGeolocation = ApiResource<
  ListAttributes,
  ListRelationships,
  ApiModel.ListGeolocation
>;
export type ListBrowserFingerprint = ApiResource<
  ListAttributes,
  ListRelationships,
  ApiModel.ListBrowserFingerprint
>;

export type ListDeviceFingerprint = ApiResource<
  ListAttributes,
  ListRelationships,
  ApiModel.ListDeviceFingerprint
>;

export type ListString = ApiResource<ListAttributes, ListRelationships, ApiModel.ListString>;

export type ListFace = ApiResource<ListAttributes, ListRelationships, ApiModel.ListFace>;
export type ListCountry = ApiResource<ListAttributes, ListRelationships, ApiModel.ListCountry>;
export type ListField = ApiResource<ListFieldAttributes, ListRelationships, ApiModel.ListField>;
export type ListSelfieBackground = ApiResource<
  ListFieldAttributes,
  ListRelationships,
  ApiModel.ListSelfieBackground
>;

export type List =
  | ListGovernmentIdNumber
  | ListIpAddress
  | ListName
  | ListPhoneNumber
  | ListEmailAddress
  | ListGeolocation
  | ListBrowserFingerprint
  | ListDeviceFingerprint
  | ListFace
  | ListString
  | ListCountry
  | ListField
  | ListSelfieBackground;
